export default "__VITE_ASSET__BCwKUy7E__"